import { Table, TableContainer, Paper, TableHead, TableRow, TableCell, TableBody } from '@mui/material';

export const VenueAuditTable = ({ columns, rows, renderCell, getRowKey }) => (
    <Paper sx={{
        width: '100%',
        overflow: 'hidden',
        bgcolor: 'background.base',
        maxWidth: 'calc(100vw - 140px)',
        borderRadius: 1,
        flexShrink: 0,
        mb: 2
    }}>
        <TableContainer sx={{
            px: 1,
            pb: 1,
            maxWidth: 'inherit',
            border: '1px solid',
            borderColor: 'primary.main',
            borderRadius: 1
        }}>
            <Table stickyHeader aria-label="sticky table">
                <TableHead>
                    <TableRow>
                        {columns.map((column) => (
                            <TableCell
                                sx={{ color: 'primary.main', px: 1.5 }}
                                key={column.id}
                                align={column.align ?? 'center'}
                                style={{ minWidth: column.minWidth, width: column.width }}
                            >
                                {column.label}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {!rows?.length
                        ? <TableRow sx={{ mx: 'auto', p: 2, color: 'grey.500' }}>
                            <TableCell colSpan={columns.length} sx={{ border: 'none', textAlign: 'center' }}>
                                No records available
                            </TableCell>
                        </TableRow>
                        : rows.map((row, rowIndex) => (
                            <TableRow hover={false} key={getRowKey(row, rowIndex)}>
                                {columns.map((column) => (
                                    <TableCell key={column.id} align={column.align ?? 'center'} sx={{ px: 1.5, py: 0.5, whiteSpace: 'nowrap' }}>
                                        {renderCell(column.id, row, rowIndex)}
                                    </TableCell>
                                ))}
                            </TableRow>
                        ))
                    }
                </TableBody>
            </Table>
        </TableContainer>
    </Paper>
);
